// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EnterUnitBasedBidPageQueryVariables = Types.Exact<{
  bidPackageId: Types.Scalars['ID']['input'];
}>;


export type EnterUnitBasedBidPageQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, bidContract?: { __typename?: 'BidContract', id: string } | null | undefined }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, isInUse: boolean, bidItem: { __typename?: 'BidItem', id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string } | null | undefined, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string }, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }> } }>, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string }, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, userSet: boolean, isTaxExempt: boolean, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined }> }> }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined } };

export type EnterUnitBasedBidPage_BidPackageFragment = { __typename?: 'BidPackage', id: string, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, bidContract?: { __typename?: 'BidContract', id: string } | null | undefined }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, isInUse: boolean, bidItem: { __typename?: 'BidItem', id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string } | null | undefined, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string }, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }> } }>, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string }, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, userSet: boolean, isTaxExempt: boolean, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined }> }> }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined };

export type EnterUnitBasedBidPage_BidItemFragment = { __typename?: 'BidItem', id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType }, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string } | null | undefined, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string }, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }> };

export type EnterUnitBasedBidPage_BidContractRevisionFragment = { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string }, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, userSet: boolean, isTaxExempt: boolean, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined }> };

export type EnterUnitBasedBidPage_SaveBidContractRevisionMutationVariables = Types.Exact<{
  input: Types.SaveBidContractRevisionInput;
}>;


export type EnterUnitBasedBidPage_SaveBidContractRevisionMutation = { __typename?: 'Mutation', saveBidContractRevision: { __typename?: 'SaveBidContractRevisionResult', bidContractRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string }, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, userSet: boolean, isTaxExempt: boolean, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined }> } } };

export const EnterUnitBasedBidPage_BidItemFragmentDoc = gql`
    fragment EnterUnitBasedBidPage_BidItem on BidItem {
  ...DisplayNamed
  costType {
    code
  }
  parentMaterialVariant {
    id
    code
    displayName
  }
  parentTask {
    id
    name
  }
  unitOfMeasure {
    id
    shortName
  }
  items {
    ...DisplayNamed
    costCode {
      ...DisplayNamed
    }
  }
}
    ${DisplayNamedFragmentDoc}`;
export const EnterUnitBasedBidPage_BidContractRevisionFragmentDoc = gql`
    fragment EnterUnitBasedBidPage_BidContractRevision on BidContractRevision {
  id
  bidContract {
    id
  }
  lineItems {
    id
    totalCostInCents
    userSet
    isTaxExempt
    bidItem {
      id
    }
  }
}
    `;
export const EnterUnitBasedBidPage_BidPackageFragmentDoc = gql`
    fragment EnterUnitBasedBidPage_BidPackage on BidPackage {
  id
  activeBidders {
    id
    name
    bidContract {
      id
    }
  }
  latestVersion {
    id
    lineItems {
      id
      isInUse
      bidItem {
        ...EnterUnitBasedBidPage_BidItem
      }
    }
    latestBidContractRevisions {
      ...EnterUnitBasedBidPage_BidContractRevision
    }
  }
  bidPackageGroup {
    id
  }
}
    ${EnterUnitBasedBidPage_BidItemFragmentDoc}
${EnterUnitBasedBidPage_BidContractRevisionFragmentDoc}`;
export const EnterUnitBasedBidPageDocument = gql`
    query EnterUnitBasedBidPage($bidPackageId: ID!) {
  bidPackage(id: $bidPackageId) {
    ...EnterUnitBasedBidPage_BidPackage
  }
}
    ${EnterUnitBasedBidPage_BidPackageFragmentDoc}`;

/**
 * __useEnterUnitBasedBidPageQuery__
 *
 * To run a query within a React component, call `useEnterUnitBasedBidPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterUnitBasedBidPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterUnitBasedBidPageQuery({
 *   variables: {
 *      bidPackageId: // value for 'bidPackageId'
 *   },
 * });
 */
export function useEnterUnitBasedBidPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EnterUnitBasedBidPageQuery, EnterUnitBasedBidPageQueryVariables> & ({ variables: EnterUnitBasedBidPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EnterUnitBasedBidPageQuery, EnterUnitBasedBidPageQueryVariables>(EnterUnitBasedBidPageDocument, options);
      }
export function useEnterUnitBasedBidPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EnterUnitBasedBidPageQuery, EnterUnitBasedBidPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EnterUnitBasedBidPageQuery, EnterUnitBasedBidPageQueryVariables>(EnterUnitBasedBidPageDocument, options);
        }
// @ts-ignore
export function useEnterUnitBasedBidPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EnterUnitBasedBidPageQuery, EnterUnitBasedBidPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnterUnitBasedBidPageQuery, EnterUnitBasedBidPageQueryVariables>;
export function useEnterUnitBasedBidPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnterUnitBasedBidPageQuery, EnterUnitBasedBidPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnterUnitBasedBidPageQuery | undefined, EnterUnitBasedBidPageQueryVariables>;
export function useEnterUnitBasedBidPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnterUnitBasedBidPageQuery, EnterUnitBasedBidPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EnterUnitBasedBidPageQuery, EnterUnitBasedBidPageQueryVariables>(EnterUnitBasedBidPageDocument, options);
        }
export type EnterUnitBasedBidPageQueryHookResult = ReturnType<typeof useEnterUnitBasedBidPageQuery>;
export type EnterUnitBasedBidPageLazyQueryHookResult = ReturnType<typeof useEnterUnitBasedBidPageLazyQuery>;
export type EnterUnitBasedBidPageSuspenseQueryHookResult = ReturnType<typeof useEnterUnitBasedBidPageSuspenseQuery>;
export type EnterUnitBasedBidPageQueryResult = ApolloReactCommon.QueryResult<EnterUnitBasedBidPageQuery, EnterUnitBasedBidPageQueryVariables>;
export const EnterUnitBasedBidPage_SaveBidContractRevisionDocument = gql`
    mutation EnterUnitBasedBidPage_SaveBidContractRevision($input: SaveBidContractRevisionInput!) {
  saveBidContractRevision(input: $input) {
    bidContractRevision {
      id
      ...EnterUnitBasedBidPage_BidContractRevision
    }
  }
}
    ${EnterUnitBasedBidPage_BidContractRevisionFragmentDoc}`;

/**
 * __useEnterUnitBasedBidPage_SaveBidContractRevisionMutation__
 *
 * To run a mutation, you first call `useEnterUnitBasedBidPage_SaveBidContractRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterUnitBasedBidPage_SaveBidContractRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterUnitBasedBidPageSaveBidContractRevisionMutation, { data, loading, error }] = useEnterUnitBasedBidPage_SaveBidContractRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnterUnitBasedBidPage_SaveBidContractRevisionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnterUnitBasedBidPage_SaveBidContractRevisionMutation, EnterUnitBasedBidPage_SaveBidContractRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnterUnitBasedBidPage_SaveBidContractRevisionMutation, EnterUnitBasedBidPage_SaveBidContractRevisionMutationVariables>(EnterUnitBasedBidPage_SaveBidContractRevisionDocument, options);
      }
export type EnterUnitBasedBidPage_SaveBidContractRevisionMutationHookResult = ReturnType<typeof useEnterUnitBasedBidPage_SaveBidContractRevisionMutation>;
export type EnterUnitBasedBidPage_SaveBidContractRevisionMutationResult = ApolloReactCommon.MutationResult<EnterUnitBasedBidPage_SaveBidContractRevisionMutation>;